
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/users/[id]/reviews",
      function () {
        return require("private-next-pages/users/[id]/reviews.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/users/[id]/reviews"])
      });
    }
  